module.exports = __webpack_public_path__ + "static/media/iconDownloadMiro.734f4198.svg";